import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import "intl";

import * as unhandledRejection from "browser-unhandled-rejection";

unhandledRejection.auto();
